import { formatCategory, formatPaginatedResponseItems, formatRequestOptions } from "../format";
import SubCategoriesAPI from "./sub";
import FollowedCategoriesAPI from "./followed";
import useRequest from "~/hooks/use-request";
import EventsAPI from "~/services/events";

const CategoriesAPI = {
  followed: FollowedCategoriesAPI,
  subCategories: SubCategoriesAPI,

  load(options?: IRequestPaginatedOptions): Promise<IPaginatedResponse<IModelCategory>> {
    const { request } = useRequest();
    const generalParams = formatRequestOptions(options);
    const params = { ...generalParams, filters: { media_type: "identity", archived: options?.archived } };

    return request
      .post<IPaginatedResponse<IResponseCategory>>("/api/identity/list", { body: params })
      .then(response => formatPaginatedResponseItems(response, formatCategory));
  },

  loadById(id: string, options?: { loadTotals: boolean }): Promise<IModelCategory> {
    const { request } = useRequest();

    return request
      .get<IContentResponse<IResponseCategory>>(`/api/identity/get_by_id/id/${id}`)
      .then(async (response) => {
        const category = formatCategory(response.content);

        if (options?.loadTotals) {
          const params = { countOnly: true, mainCategoryId: id };

          await Promise.all([
            EventsAPI.load({ ...params, type: "archived" }), // latest events
            EventsAPI.load({ ...params, type: "upcoming" }), // upcoming events
            EventsAPI.load({ ...params, type: "live" }), // live events
          ]).then(([res1, res2, res3]) => {
            category.totalVodEventsNumber = res1.content.count;
            category.totalUpcomingEventsNumber = res2.content.count;
            category.totalLiveEventsNumber = res3.content.count;
            category.totalEventsNumber = category.totalVodEventsNumber + category.totalUpcomingEventsNumber + category.totalLiveEventsNumber;
          });
        }
        return category;
      });
  },

  async loadWithSubcategories() {
    const { content: { entries: categories } } = await CategoriesAPI.load({ page: 0, pageSize: 100 });
    const { content: { entries: subcategories } } = await SubCategoriesAPI.loadAllSubCategory();

    return categories.map((category) => {
      return {
        ...category,
        subCategories: subcategories.filter(subcategory => subcategory.mainCategories.includes(category.id)),
      };
    });
  },
};

export default CategoriesAPI;
